var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundedInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26934 5.25H10.8151V6.75H9.26934V5.25ZM9.26934 8.25H10.8151V12.75H9.26934V8.25ZM10.0422 1.5C5.77589 1.5 2.31335 4.86 2.31335 9C2.31335 13.14 5.77589 16.5 10.0422 16.5C14.3086 16.5 17.7711 13.14 17.7711 9C17.7711 4.86 14.3086 1.5 10.0422 1.5ZM10.0422 15C6.63379 15 3.85913 12.3075 3.85913 9C3.85913 5.6925 6.63379 3 10.0422 3C13.4507 3 16.2253 5.6925 16.2253 9C16.2253 12.3075 13.4507 15 10.0422 15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedInfo);
export default __webpack_public_path__ + "static/media/rounded-info.bdc46179.svg";
export { ForwardRef as ReactComponent };